"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemToastContainer = exports.SystemToast = exports.SYSTEM_TOAST_CLOSE_BUTTON_TEST_ID = exports.DEFAULT_DISMISS_MS = exports.CONTAINER_TEST_ID = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ExclamationMarkTriangle = _interopRequireDefault(require("@honeybook/icons/dist/icons/ExclamationMarkTriangle24"));
var _CheckCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/CheckCircle24"));
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle24"));
var _HBToast = require("../HBToast.types");
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _HBText = _interopRequireDefault(require("../../HBText/HBText"));
var _breakpoints = require("../../../styles/breakpoints");
var _animations = require("../../../styles/animations");
var _ToastActions = _interopRequireDefault(require("../ToastActions"));
var _ToastActionLink = _interopRequireDefault(require("../ToastActionLink"));
var _mixins = require("../../../styles/mixins");
var _styledIs = _interopRequireDefault(require("styled-is"));
var _HBAvatarAI = _interopRequireDefault(require("../../HBAvatarAI/HBAvatarAI"));
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DEFAULT_DISMISS_MS = exports.DEFAULT_DISMISS_MS = 5000;
var CONTAINER_TEST_ID = exports.CONTAINER_TEST_ID = 'hb-toast--container';
var SYSTEM_TOAST_CLOSE_BUTTON_TEST_ID = exports.SYSTEM_TOAST_CLOSE_BUTTON_TEST_ID = 'hb-system-toast-close--button';
var DEFAULT_ICONS = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBToast.ToastType.Error, _ExclamationMarkTriangle["default"]), _HBToast.ToastType.Success, _CheckCircle["default"]), _HBToast.ToastType.Info, _InfoCircle["default"]), _HBToast.ToastType.ai, function () {
  return /*#__PURE__*/_react["default"].createElement(_HBAvatarAI["default"], {
    size: "sm"
  });
});
var SystemToast = exports.SystemToast = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var iconColor = _ref.iconColor,
    id = _ref.id,
    type = _ref.type,
    title = _ref.title,
    text = _ref.text,
    _ref$isDismissible = _ref.isDismissible,
    isDismissible = _ref$isDismissible === void 0 ? true : _ref$isDismissible,
    _ref$autoDismissMs = _ref.autoDismissMs,
    autoDismissMs = _ref$autoDismissMs === void 0 ? isDismissible ? DEFAULT_DISMISS_MS : 0 : _ref$autoDismissMs,
    onDismiss = _ref.onDismiss,
    removeItem = _ref.removeItem,
    _ref$icon = _ref.icon,
    Icon = _ref$icon === void 0 ? DEFAULT_ICONS[type] : _ref$icon,
    actions = _ref.actions,
    actionLink = _ref.actionLink,
    customColor = _ref.customColor,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'column' : _ref$layout;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isRendered = _useState4[0],
    setIsRendered = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isHovered = _useState6[0],
    setIsHovered = _useState6[1];
  var timeoutRef = (0, _react.useRef)();
  var onAnimationEnd = function onAnimationEnd() {
    if (!isVisible) {
      setIsRendered(false);
      removeItem(id);
    }
  };
  var dismiss = (0, _react.useCallback)(function () {
    setIsVisible(false);
    onDismiss === null || onDismiss === void 0 || onDismiss();
  }, [onDismiss]);
  var onActionClick = function onActionClick(action) {
    action === null || action === void 0 || action.onClick();
    dismiss();
  };
  (0, _react.useEffect)(function () {
    if (typeof autoDismissMs !== 'number' || !autoDismissMs || !isVisible || isHovered) {
      return;
    }
    timeoutRef.current = setTimeout(dismiss, autoDismissMs);
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isDismissible, dismiss, autoDismissMs, isVisible, isHovered]);
  if (!isRendered) {
    return null;
  }
  var isAiTheme = type === _HBToast.ToastType.ai;
  return /*#__PURE__*/_react["default"].createElement(SystemToastContainer, {
    isVisible: isVisible,
    isAiTheme: isAiTheme,
    onAnimationEnd: onAnimationEnd,
    "data-testid": CONTAINER_TEST_ID,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(Bar, {
    type: type,
    customColor: customColor,
    isAiTheme: isAiTheme
  }), /*#__PURE__*/_react["default"].createElement(ContentContainer, null, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    color: iconColor || _colors["default"].neutral800
  }), /*#__PURE__*/_react["default"].createElement(ContentWrapper, {
    layout: layout,
    type: type
  }, /*#__PURE__*/_react["default"].createElement(TextWrapper, null, typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement(ToastTitle, null, title) : title, text ? /*#__PURE__*/_react["default"].createElement(ToastText, {
    type: "body14"
  }, text) : null), actions && /*#__PURE__*/_react["default"].createElement(ActionsWrapper, null, /*#__PURE__*/_react["default"].createElement(_ToastActions["default"], {
    actions: actions,
    onActionClick: onActionClick
  })), actionLink && /*#__PURE__*/_react["default"].createElement(_ToastActionLink["default"], {
    actionLink: actionLink,
    onActionClick: onActionClick
  })), isDismissible && /*#__PURE__*/_react["default"].createElement(StyledXIcon, {
    "data-testid": SYSTEM_TOAST_CLOSE_BUTTON_TEST_ID,
    color: _colors["default"].neutral800,
    onClick: dismiss
  })));
});

// -------------------------------- Styles -------------------------------- //
function getAnimation(_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? (0, _styledComponents.css)(["animation:", " 0.7s;"], (0, _animations.fromDirection)('right')) : (0, _styledComponents.css)(["animation:", " 0.7s;"], (0, _animations.dissolve)('up'));
}
function barColorByType(type) {
  var customColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  switch (type) {
    case _HBToast.ToastType.Error:
      return _colors["default"].red50;
    case _HBToast.ToastType.Success:
      return _colors["default"].green40;
    case _HBToast.ToastType.Info:
      return _colors["default"].blue20;
    case _HBToast.ToastType.CustomInfo:
      return customColor;
    case _HBToast.ToastType.ai:
      return 'transparent';
    default:
      return _colors["default"].neutral900;
  }
}
var SystemToastContainer = exports.SystemToastContainer = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__SystemToastContainer",
  componentId: "sc-sjajvg-0"
})(["display:flex;position:relative;width:100%;margin-bottom:8px;background-color:", ";border-radius:4px;box-shadow:0 14px 28px 0 ", ",0 0 10px 0 ", ";transition:transform 0.6s ease-in-out,opacity 400ms;", " ", "{min-width:320px;max-width:480px;}", ""], _colors["default"].white, _colors["default"].blue_015, _colors["default"].blue_008, getAnimation, _breakpoints.mediumUp, (0, _styledIs["default"])('isAiTheme')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n        ", ";\n    "])), _mixins.aiInlineFillBackground, _mixins.aiLayeredBoxShadow));
var Bar = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__Bar",
  componentId: "sc-sjajvg-1"
})(["width:4px;margin:4px 0 4px 4px;border-radius:1px;background-color:", ";", ""], function (props) {
  return barColorByType(props.type, props.customColor);
}, (0, _styledIs["default"])('isAiTheme')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        background: ", ";\n    "])), _mixins.aiAccentLineGradient));
var ContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__ContentContainer",
  componentId: "sc-sjajvg-2"
})(["padding:16px 20px 16px 10px;display:flex;width:100%;"]);
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__ContentWrapper",
  componentId: "sc-sjajvg-3"
})(["width:100%;margin-left:10px;display:flex;flex-direction:", ";align-items:", ";justify-content:space-between;"], function (props) {
  return props.layout;
}, function (props) {
  return props.layout === 'column' ? 'normal' : 'center';
});
var StyledXIcon = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "SystemToast__StyledXIcon",
  componentId: "sc-sjajvg-4"
})(["margin-inline-start:12px;margin-top:6px;"]);
var ToastTitle = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'emphasis14',
  color: 'neutral900'
}).withConfig({
  displayName: "SystemToast__ToastTitle",
  componentId: "sc-sjajvg-5"
})(["padding-top:3px;"]);
var ToastText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "SystemToast__ToastText",
  componentId: "sc-sjajvg-6"
})(["padding-top:3px;padding-right:28px;white-space:pre-line;"]);
var ActionsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__ActionsWrapper",
  componentId: "sc-sjajvg-7"
})(["display:flex;justify-content:flex-end;margin-top:20px;"]);
var TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SystemToast__TextWrapper",
  componentId: "sc-sjajvg-8"
})(["display:flex;flex-direction:column;"]);
//# sourceMappingURL=SystemToast.js.map